import React from "react";

class RadioGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.value };
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(event) {
    this.setState({ value: event.target.value });
    this.props.onChange(event.target.value);
  }

  render() {
    const { name, options } = this.props;
    const { value } = this.state;

    return (
      <div>
        {options.map((option) => (
          <label style={{marginRight:"20px"}} key={option.value}>
            <input
            style={{marginRight:"5px"}}
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={this.handleOptionChange}
            />
            {option.label}
          </label>
        ))}
      </div>
    );
  }
}
export default RadioGroup;



// WEBPACK FOOTER //
// ./src/component/RadioGroup.js